import {
   SET_HUBBLE_FORMS,
   SET_SINGLE_HUBBLE_FORM,
   SET_HUBBLE_CURRENT_PAGE,
   SET_HUBBLE_TOTAL_DOCS,
   SET_HUBBLE_TOTAL_PAGES,
   SET_HUBBLE_JUDGES,
   SET_HUBBLE_REFEREE,
   SET_HUBBLE_REFEREE_CURRENT_PAGE,
   SET_HUBBLE_REFEREE_TOTAL_DOCS,
   SET_HUBBLE_REFEREE_TOTAL_PAGES,
   SET_SINGLE_HUBBLE_REFEREE,
   SET_SELECTED_JUDGE,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    hubbleForms: [],
    hubbleForm: null,
    hubbleCurrentPage: 0,
    hubbleTotalPages: 0,
    hubbleTotalDocs: 0,
    hubbleJudges: [],
    hubbleReferee: [],
    hubbleRefereeCurrentPage: 0,
    hubbleRefereeTotalPages: 0,
    hubbleRefereeTotalDocs: 0,
    hubbleSingleReferee: null,
    selectedJudge: ''
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_HUBBLE_FORMS: {
            return {
                ...state,
                hubbleForms: action.payload,
            };
        }
        case SET_HUBBLE_CURRENT_PAGE: {
            return {
                ...state,
                hubbleCurrentPage: action.payload,
            };
        }
        case SET_HUBBLE_TOTAL_PAGES: {
            return {
                ...state,
                hubbleTotalPages: action.payload,
            };
        }
        case SET_HUBBLE_TOTAL_DOCS: {
            return {
                ...state,
                hubbleTotalDocs: action.payload,
            };
        }
        case SET_SINGLE_HUBBLE_FORM: {
            return {
                ...state,
                hubbleForm: action.payload,
            };
        }
        case SET_HUBBLE_JUDGES: {
            return {
                ...state,
                hubbleJudges: action.payload,
            };
        }
        case SET_HUBBLE_REFEREE: {
            return {
                ...state,
                hubbleReferee: action.payload,
            };
        }
        case SET_HUBBLE_REFEREE_CURRENT_PAGE: {
            return {
                ...state,
                hubbleRefereeCurrentPage: action.payload,
            };
        }
        case SET_HUBBLE_REFEREE_TOTAL_DOCS: {
            return {
                ...state,
                hubbleRefereeTotalDocs: action.payload,
            };
        }
        case SET_HUBBLE_REFEREE_TOTAL_PAGES: {
            return {
                ...state,
                hubbleRefereeTotalPages: action.payload,
            };
        }
        case SET_SINGLE_HUBBLE_REFEREE: {
            return {
                ...state,
                hubbleSingleReferee: action.payload,
            };
        }
        case SET_SELECTED_JUDGE: {
            return {
                ...state,
                selectedJudge: action.payload,
            };
        }
        default:
            return state;
    }
};